import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

const StyledCloseButton = styled.div(({
  theme: {
    colors,
    indents,
  },
}) => ({
  boxSizing: 'border-box',
  position: 'absolute',
  top: indents.INDENT_2,
  right: indents.INDENT_2,
  cursor: 'pointer',
  color: colors.TEXT_PRIMARY,
  outline: 'none',
}));

type CloseButtonProps = {
  onClick: () => void;
};

export function CloseButton({
  onClick,
}: CloseButtonProps): ReactElement {
  return (
    <StyledCloseButton
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 5.875L14.125 5L10 9.125L5.875 5L5 5.875L9.125 10L5 14.125L5.875 15L10 10.875L14.125 15L15 14.125L10.875 10L15 5.875Z" />
      </svg>
    </StyledCloseButton>
  );
}
